import { Component, Element, Event, EventEmitter, h, Host, Prop } from "@stencil/core";

enum Directions {
    Asc = "asc",
    Desc = "desc",
    None = ""
}

@Component({
    tag: "ux-table-data-sort",
    styleUrl: "table-data-sort.scss",
    shadow: false
})
export class TableDataSort {
    @Element() domElement!: HTMLUxTableDataSortElement;
    /** This is the name of the sort field used in the sort click event */
    @Prop() readonly sortField: string;
    /** indicates in which direction the data is already sorted. This has to be empty when it is not sorted yet.
     * Setting this does not trigger the sorting event. Clicking the button will update this attribute. */
    /* eslint-disable-next-line */
    @Prop({ reflect: true }) sortedDirection: "" | "asc" | "desc" = "";
    /** when the sort Button is clicked it emits the asc or desc name  */
    @Event({
        eventName: "uxTableSort",
        composed: true,
        cancelable: true,
        bubbles: true
    })
    sortEvent!: EventEmitter;

    private sort(): void {
        switch (this.sortedDirection) {
            case Directions.Asc:
                this.sortedDirection = Directions.Desc;
                break;
            case Directions.Desc:
                this.sortedDirection = Directions.None;
                break;
            default:
                this.sortedDirection = Directions.Asc;
        }

        this.sortEvent.emit({
            name: this.sortField,
            direction: this.sortedDirection
        });
        // @ts-expect-error Check for typing
        const allSorters = this.domElement.closest("tr").querySelectorAll("ux-table-data-sort");
        [].forEach.call(allSorters, (element: HTMLUxTableDataSortElement) => {
            if (element.isEqualNode(this.domElement)) {
                return;
            }
            element.sortedDirection = Directions.None;
        });
    }

    render() {
        const baseClass = "ux-table-data-sort";
        return (
            <Host class={baseClass} onClick={() => this.sort()}>
                <slot />
                &nbsp;
                <ux-icon class={`${baseClass}__icon`} name="sort" weight="bold" />
            </Host>
        );
    }
}
